<template>
  <UserApp
    :transition-name="transitionName"
    :transition-mode="transitionMode"
    user-type="mentor"
  >
    <ul class="tw-block pl-body tw-pr-4 tw-max-w-full" slot="side-nav">
      <router-link
        tag="li"
        to="/app"
        class="hover:tw-bg-gray-200 tw-cursor-pointer tw-flex tw-items-center tw-py-4 tw-px-5 tw--ml-5 tw-rounded-full tw-text-base tw-uppercase tw-fill-current align-middle leading-24"
      >
        <svg class="tw-w-6 tw-h-6 tw-mr-4 tw-inline-block" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
          <path d="M61.4,33.8v29.8c0,2.3-2,4.3-4.3,4.3H45.6c-2.3,0-4.3-2-4.3-4.3V50.9c0-0.4-0.4-0.7-0.7-0.7h-8.3c-0.4,0-0.7,0.4-0.7,0.7
            v12.8c0,2.3-2,4.3-4.3,4.3H15.4c-2.3,0-4.3-2-4.3-4.3V33.8c0-1.1,0.7-1.8,1.8-1.8s1.8,0.7,1.8,1.8v29.8c0,0.4,0.4,0.7,0.7,0.7h11.9
            c0.4,0,0.7-0.4,0.7-0.7V50.9c0-2.3,2-4.3,4.3-4.3h8.3c2.3,0,4.3,2,4.3,4.3v12.8c0,0.4,0.4,0.7,0.7,0.7h11.5c0.4,0,0.7-0.4,0.7-0.7
            V33.8c0-1.1,0.7-1.8,1.8-1.8C60.7,32,61.4,32.9,61.4,33.8z M71.3,30.6L37,4.6c-1.1-0.7-2.3-0.7-3.4,0L0.7,30.8
            c-0.7,0.5-0.9,1.8-0.4,2.5C0.7,33.7,1.2,34,1.8,34c0.4,0,0.7-0.2,1.1-0.4L35.2,8l34,25.7c0.7,0.5,2,0.5,2.5-0.4
            C72.2,32.4,72.2,31.3,71.3,30.6z"/>
        </svg>
        <span class="tw-inline-block tw-text-base tw-uppercase leading-24">
          Home
        </span>
      </router-link>
      <router-link
        tag="li"
        to="/app/my-mentees"
        class="hover:tw-bg-gray-200 tw-cursor-pointer tw-flex tw-items-center tw-py-4 tw-px-5 tw--ml-5 tw-rounded-full tw-text-base tw-uppercase tw-fill-current align-middle leading-24"
      >
        <svg class="tw-w-6 tw-h-6 tw-mr-4 tw-inline-block" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
          <path d="M36,72C16.1,72,0,55.9,0,36S16.1,0,36,0s36,16.1,36,36S55.9,72,36,72z M36,4.8C18.7,4.8,4.8,18.7,4.8,36S18.7,67.2,36,67.2
            S67.2,53.3,67.2,36S53.3,4.8,36,4.8z M49.4,48.2c1-0.7,1.2-2.4,0.5-3.4s-2.4-1.2-3.4-0.5C43.2,46.8,39.8,48,36,48s-7.4-1.2-10.8-3.8
            c-1-0.7-2.6-0.5-3.4,0.5c-0.7,1-0.5,2.6,0.5,3.4c4.1,3.1,8.9,4.8,13.7,4.8C40.8,52.8,45.4,51.4,49.4,48.2z M28.8,31.2v-4.8
            c0-1.4-1-2.4-2.4-2.4S24,25,24,26.4v4.8c0,1.4,1,2.4,2.4,2.4S28.8,32.6,28.8,31.2z M48,31.2v-4.8c0-1.4-1-2.4-2.4-2.4
            s-2.4,1-2.4,2.4v4.8c0,1.4,1,2.4,2.4,2.4C47,33.6,48,32.6,48,31.2z"/>
        </svg>
        <span class="tw-inline-block tw-text-base tw-uppercase leading-24">
          My Mentees
        </span>
        <NotificationPill
          v-if="totalNewMessages > 0"
          :total="totalNewMessages"
          class="tw-mr-1 tw-ml-auto"
        />
      </router-link>
      <router-link
        tag="li"
        to="/app/resources"
        class="hover:tw-bg-gray-200 tw-cursor-pointer tw-flex tw-items-center tw-py-4 tw-px-5 tw--ml-5 tw-rounded-full tw-text-base tw-uppercase tw-fill-current align-middle leading-24"
      >
        <svg class="tw-w-6 tw-h-6 tw-mr-4 tw-inline-block" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
          y="0px" viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
          <path d="M62.1,14h-8.8c-0.8,0-1.6-0.6-1.6-1.6V2.6C52,1.2,50.8,0,49.4,0H12.1c-2.8,0-5,2.2-5,5v62c0,2.8,2.2,5,5,5h47.9
            c2.8,0,5-2.2,5-5V16.6C64.9,15.2,63.7,14,62.1,14z M60.9,66.8c0,0.6-0.4,1-1,1H12.1c-0.6,0-1-0.4-1-1V5c0-0.6,0.6-1,1-1H48v8.4
            c0,3,2.4,5.6,5.6,5.6h7.4V66.8z M51,29.9c0,1.2-0.8,2-2,2H23c-1.2,0-2-0.8-2-2s0.8-2,2-2H49C50.2,27.9,51,28.7,51,29.9z M51,41.9
            c0,1.2-0.8,2-2,2H23c-1.2,0-2-0.8-2-2c0-1.2,0.8-2,2-2H49C50.2,39.9,51,40.7,51,41.9z M51,53.9c0,1.2-0.8,2-2,2H23c-1.2,0-2-0.8-2-2
            s0.8-2,2-2H49C50.2,51.9,51,52.7,51,53.9z"/>
        </svg>
        <span class="tw-inline-block tw-text-base tw-uppercase leading-24">
          Resources
        </span>
      </router-link>
      <router-link
        tag="li"
        to="/app/profile"
        class="hover:tw-bg-gray-200 tw-cursor-pointer tw-flex tw-items-center tw-py-4 tw-px-5 tw--ml-5 tw-rounded-full tw-text-base tw-uppercase tw-fill-current align-middle leading-24"
      >
        <svg class="tw-w-6 tw-h-6 tw-mr-4 tw-inline-block" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
          <path d="M46.9,39.5C53,35.6,57.1,29,57.1,21.3C57.1,9.5,47.7,0,35.9,0S14.6,9.5,14.6,21.3c0,7.7,4.1,14.3,10.2,18.2
            C12.6,43.8,3.3,55.3,2.3,69.2c0,0.8,0.3,1.3,0.8,2C3.6,72,4.4,72,4.9,72h62.3c0.8,0,1.3-0.3,1.8-0.8s0.8-1.3,0.8-2
            C68.7,55.3,59.4,43.8,46.9,39.5z M19.7,21.3c0-9,7.2-16.1,16.1-16.1S52,12.3,52,21.3s-7.2,16.1-16.1,16.1S19.7,30.2,19.7,21.3z
            M7.7,66.6C10,53,21.8,42.5,35.9,42.5S62,52.8,64.1,66.6H7.7z"/>
        </svg>
        <span class="tw-inline-block tw-text-base tw-uppercase leading-24">
          Profile
        </span>
      </router-link>
      <router-link
        tag="li"
        to="/app/settings"
        class="hover:tw-bg-gray-200 tw-cursor-pointer tw-flex tw-items-center tw-py-4 tw-px-5 tw--ml-5 tw-rounded-full tw-text-base tw-uppercase tw-fill-current align-middle leading-24"
      >
        <svg class="tw-w-6 tw-h-6 tw-mr-4 tw-inline-block" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
          <path d="M55.1,70.4c-0.9,0-1.8-0.2-2.5-0.7l-16.1-8.4c-0.2-0.2-0.5-0.2-0.9,0l-16.1,8.6c-1.8,0.9-4.1,0.9-5.7-0.5
            c-1.6-1.1-2.5-3.2-2-5.2l3.2-18c0-0.2,0-0.7-0.2-0.7l-13-12.7c-1.6-1.4-2-3.6-1.4-5.5c0.7-2,2.3-3.4,4.3-3.6l18-2.5
            c0.2,0,0.5-0.2,0.7-0.5l8-16.4c0.9-1.8,2.7-3,4.8-3c2,0,3.9,1.1,4.8,3l0,0l8,16.4c0.2,0.2,0.5,0.5,0.7,0.5l18,2.5
            c2,0.2,3.6,1.8,4.3,3.6c0.7,2,0.2,4.1-1.4,5.5l-13,12.7c-0.2,0.2-0.2,0.5-0.2,0.7l3.2,18c0.5,2-0.5,4.1-2,5.2
            C57.1,70.1,56.2,70.4,55.1,70.4z M36,56.7c0.9,0,1.8,0.2,2.5,0.7l16.1,8.4c0.5,0.2,0.7,0,0.9,0c0.2-0.2,0.5-0.5,0.5-0.9l-3.2-18
            c-0.2-1.8,0.2-3.6,1.6-4.8l13-12.7c0.2-0.2,0.2-0.7,0.2-0.9c0-0.2-0.2-0.5-0.7-0.7l-18-2.5c-1.8-0.2-3.2-1.4-4.1-3L36.7,6.2l0,0
            C36.5,5.8,36,5.8,36,5.8s-0.7,0-0.7,0.5l-8,16.4c-0.7,1.6-2.3,2.7-4.1,3l-18,2.5c-0.5,0-0.7,0.5-0.7,0.7c0,0.2-0.2,0.5,0.2,0.9
            l13,12.7c1.4,1.1,1.8,3,1.6,4.8l-3.2,18c0,0.5,0.2,0.7,0.5,0.9c0.2,0.2,0.5,0.2,0.9,0l16.1-8.4C34.2,56.9,35.1,56.7,36,56.7z"/>
        </svg>
        <span class="tw-inline-block tw-text-base tw-uppercase leading-24">
          Expertise
        </span>
      </router-link>

      <!-- <router-link
        tag="li"
        to="/app/wallet"
        class="tw-cursor-pointer tw-flex tw-items-center tw-py-4 tw-px-5 tw--ml-5 tw-rounded-full tw-text-base tw-uppercase tw-fill-current align-middle leading-24 opacity-11"
      >
        <svg class="tw-w-6 tw-h-6 tw-mr-4 tw-inline-block" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
          y="0px" viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
          <path d="M62.7,11.3H9.3c-5.1,0-9.3,4.1-9.3,9.3v30.9c0,5.1,4.1,9.3,9.3,9.3h53.5c5.1,0,9.3-4.1,9.3-9.3V20.6
            C72,15.4,67.9,11.3,62.7,11.3z M9.3,15.4h53.5c2.9,0,5.1,2.3,5.1,5.1v1H4.1v-1C4.1,17.7,6.4,15.4,9.3,15.4z M67.9,25.7v4.1H4.1v-4.1
            H67.9z M62.7,56.6H9.3c-2.9,0-5.1-2.3-5.1-5.1V33.9h63.8v17.5C67.9,54.3,65.6,56.6,62.7,56.6z M61.7,48.3c0,1.2-0.8,2.1-2.1,2.1
            H45.3c-1.2,0-2.1-0.8-2.1-2.1s0.8-2.1,2.1-2.1h14.4C60.9,46.3,61.7,47.1,61.7,48.3z"/>
        </svg>
        <span class="tw-inline-block tw-text-base tw-uppercase leading-24">
          Wallet
        </span>
      </router-link> -->
      <router-link
        tag="li"
        :to="`/app/${ellyOrEbby.toLowerCase()}`"
        class="hover:tw-bg-gray-200 tw-cursor-pointer tw-flex tw-items-center tw-py-4 tw-px-5 tw--ml-5 tw-rounded-full tw-text-base tw-uppercase tw-fill-current align-middle leading-24"
      >
        <!-- <img
          class="tw-w-6 tw-h-6 tw-mr-4 tw-inline-block tw-bg-gray-800 tw-rounded-full tw-flex-shrink-0"
          :src="`/img/support_${ellyOrEbby.toLowerCase()}.png`"
        > -->
        <svg class="tw-w-6 tw-h-6 tw-mr-4 tw-inline-block" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
          <path d="M64.7,29.6h-1.9c-0.6,0-1.2,0.2-1.8,0.4v-5C61,11.2,49.8,0,36,0S11,11.2,11,25v5c-0.5-0.3-1.1-0.4-1.8-0.4H7.3
            c-2.3,0-4.1,1.8-4.1,4.1v11.7c0,2.3,1.8,4.1,4.1,4.1h1.9c2.3,0,4.1-1.8,4.1-4.1v-9.6v-2.2V25C13.3,12.5,23.5,2.3,36,2.3
            S58.7,12.5,58.7,25v8.7v2.9v8.8v17c0,2.4-1.9,4.3-4.3,4.3h-10v-2.2c0-0.6-0.5-1.2-1.2-1.2H28.8c-0.6,0-1.2,0.5-1.2,1.2v6.3
            c0,0.6,0.5,1.2,1.2,1.2h14.3c0.6,0,1.2-0.5,1.2-1.2v-1.8h10c3.7,0,6.6-3,6.6-6.6V49.2c0.5,0.3,1.1,0.4,1.8,0.4h1.9
            c2.3,0,4.1-1.8,4.1-4.1V33.7C68.8,31.5,67,29.6,64.7,29.6z M11,45.5c0,1-0.8,1.8-1.8,1.8H7.3c-1,0-1.8-0.8-1.8-1.8V33.7
            c0-1,0.8-1.8,1.8-1.8h1.9c1,0,1.8,0.8,1.8,1.8v2.2V45.5z M42,69.7H30v-3.9h12L42,69.7L42,69.7z M66.5,45.5c0,1-0.8,1.8-1.8,1.8h-1.9
            c-1,0-1.8-0.8-1.8-1.8v-8.8v-2.9c0-1,0.8-1.8,1.8-1.8h1.9c1,0,1.8,0.8,1.8,1.8V45.5z"/>
          <!-- <circle cx="24.6" cy="26.6" r="4.6"/>
          <circle cx="47.4" cy="26.6" r="4.6"/> -->
        </svg>
        <span class="tw-inline-block tw-text-base tw-uppercase tw-align-baseline leading-24">
          {{ ellyOrEbby  }} <span class="tw-lowercase opacity-31 tw-text-xs">(Admin support)</span>
        </span>
      </router-link>

      <li
        class="hover:tw-bg-gray-200 tw-cursor-pointer tw-flex tw-items-center tw-py-4 tw-px-5 tw--ml-5 tw-rounded-full tw-text-base tw-uppercase tw-fill-current align-middle leading-24"
        @click="logout();"
      >
        <svg class="tw-w-6 tw-h-6 tw-mr-4 tw-inline-block" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
          <g>
            <path d="M47.4,7.7c-1.2-0.5-2.6,0.2-3,1.4c-0.5,1.2,0.2,2.6,1.4,3C57.1,16,64.6,26.9,64.6,39c0,15.8-12.8,28.6-28.6,28.6
              S7.7,54.6,7.7,38.8c0-12.1,7.7-22.8,18.8-26.9c1.2-0.5,1.9-1.9,1.4-3c-0.5-1.2-1.9-1.9-3-1.4C11.6,12.1,2.8,24.6,2.8,38.8
              C2.8,57.1,17.6,72,36,72s33.2-14.9,33.2-33.2C69.4,24.9,60.6,12.3,47.4,7.7z"/>
            <path d="M36.2,34.6c1.4,0,2.3-0.9,2.3-2.3v-30c0-1.4-0.9-2.3-2.3-2.3s-2.3,0.9-2.3,2.3v30C33.9,33.4,34.8,34.6,36.2,34.6z"/>
          </g>
        </svg>
        <span class="tw-inline-block tw-text-base tw-uppercase leading-24" style="line-height: 24px;">
          Logout
        </span>
      </li>
    </ul>
  </UserApp>
</template>

<script>
import UserApp from '@/views/_partials/UserApp.vue';
import userApp from '@/mixins/userApp';
import mentorStore from '@/store/mentor/index';
import { getRouteNames } from '@/modules/misc';
import NotificationPill from '@/components/NotificationPill.vue';

const viewRoutes = [];

export default {
  name: 'MentorApp',
  components: {
    UserApp,
    NotificationPill,
  },
  mixins: [userApp],
  data() {
    return {
      transitionName: 'fade',
      transitionMode: 'in-out',
      ellyOrEbby: this.$store.getters.getBotName,
    };
  },
  async created() {
    window.localStorage.setItem('ema-app-bot-name', this.ellyOrEbby);

    viewRoutes.push(...getRouteNames(this.$router.options.routes));

    if (this.isMentor) {
      await this.registerUserStoreModule('mentor', mentorStore);
    } else {
      await this.logout('You need to log in.');
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (viewRoutes.find(r => r === from.name) || viewRoutes.find(r => r === to.name)) {
      // if in mentee page, no transition
      if (
        (from.name === 'mentorMenteeProfile'
        && to.name === 'mentorMenteeTasks')
        || (from.name === 'mentorMenteeProfile'
        && to.name === 'mentorMenteeChat')
        || (from.name === 'mentorMenteeTasks'
        && to.name === 'mentorMenteeProfile')
        || (from.name === 'mentorMenteeTasks'
        && to.name === 'mentorMenteeChat')
        || (from.name === 'mentorMenteeChat'
        && to.name === 'mentorMenteeProfile')
        || (from.name === 'mentorMenteeChat'
        && to.name === 'mentorMenteeTasks')
      ) {
        this.transitionName = 'no-transition';
        this.transitionMode = 'out-in';
      } else if (
        (to.name === 'app' || to.name === 'mentorMenteesView')
        && from.name !== 'profile'
        && from.name !== 'mentorMenteesView'
        && from.name !== 'app'
      ) {
        this.transitionName = 'slide-view-back';
        this.transitionMode = 'out-in';
      } else if (
        (to.name === 'mentorMenteeTasks' || to.name === 'mentorMenteeChat'
        || to.name === 'mentorMenteeProfile')
        && (from.name !== 'mentorMenteeTasks' || from.name !== 'mentorMenteeChat'
        || from.name !== 'mentorMenteeProfile')
      ) {
        this.transitionName = 'slide-view';
        this.transitionMode = 'in-out';
      } else if (
        to.name === 'resources' || to.name === 'settings'
        || from.name === 'resources' || from.name === 'settings'
        || to.name === 'mentorMenteeView' || to.name === 'menteeBio'
      ) {
        this.transitionName = 'slide-view';
        this.transitionMode = 'in-out';
      } else {
        this.transitionName = 'fade';
        this.transitionMode = 'out-in';
      }
    }
    // console.log('APP TRANSITION', this.transitionName, to.name);
    next();
  },
};
</script>

<style scoped>
</style>
